import { ReactNode, useMemo } from 'react';
// import { GridApi } from 'ag-grid-community';
import { Card } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  DataGrid,
  DataGridApiProvider,
  DataGridProps,
  InitialConstraints,
} from 'app/common/ui/data-grid';
import { ColumnsSettings } from 'app/common/ui/data-grid/columns-settings';
import { BaseFilterModel } from 'app/common/ui/data-grid/filters';
import { FiltersSettings } from 'app/common/ui/data-grid/filters-settings/filters-settings';
import {
  FullscreenExpandButton,
  useFullscreenExpand,
} from 'app/common/ui/data-grid/fullscreen-expand';
import { Loading } from 'app/ui';

import { useEntityGridConfig } from '../entity-grid/entity-grid-config.provider';
import { prepareDataGridConstraints } from './prepare-data-grid-constraints';
import { prepareEnityGridConstraints } from './prepare-initial-constraints';

import styles from './entity-grid-table.module.css';

const getRowId = (params: any) => params.data.id;

type EntityGridTableProps = DataGridProps & {
  actions?: ReactNode | ReactNode[];
  mapResourceContent?: (data: any) => any;
};

export const EntityGridTable = observer((props: EntityGridTableProps) => {
  const entityGridConfig = useEntityGridConfig();
  const loading = entityGridConfig.resource.isLoading;
  const columns = entityGridConfig.columns.data;
  const rowData = props?.mapResourceContent
    ? props?.mapResourceContent(entityGridConfig.resource.data)
    : entityGridConfig.resource.data.content;

  console.log(rowData);
  const recordsLimit = entityGridConfig.constraints.recordsLimit;
  const constraints = entityGridConfig.constraints;
  const extraFilters = entityGridConfig.extraFilters.filters;

  const showIsOverRecordLimit =
    typeof recordsLimit === 'number' && rowData.length >= recordsLimit;

  const dataGridInitialConstaints = useMemo(() => {
    const constraints = entityGridConfig.constraints.data;
    const dataGridConstraints = prepareEnityGridConstraints({
      columns,
      constraints,
    });

    return dataGridConstraints;
  }, [columns, entityGridConfig.constraints.data]);

  const handleChange = (data: InitialConstraints) => {
    const constraints = entityGridConfig.constraints;
    const entityGridConstraints = prepareDataGridConstraints({
      constraints: data,
      rowModelType: constraints.rowModelType,
      recordsLimit: constraints.recordsLimit,
    });

    constraints.updateConstraints(entityGridConstraints);
  };

  const handleExtraFilterChange = (model: BaseFilterModel<unknown, string>) => {
    const constraints = entityGridConfig.constraints;
    constraints.updateFilters({ [model.filterName]: model.value });
  };

  const { expandRef, toogleExpand, isExpanded } =
    useFullscreenExpand<HTMLDivElement>();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        rowGap: 16,
      }}
    >
      {showIsOverRecordLimit && (
        <Card size="small">
          Запрошен большой объем данных. Показаны результаты для первых{' '}
          {recordsLimit} из{' '}
          {entityGridConfig.resource.data?.totalElements ?? '???'} записей.
          Воспользуйтесь фильтрами для уточнения результатов.
        </Card>
      )}

      <Card
        ref={expandRef}
        size="small"
        className={styles.entityGridCard}
        style={{ flexGrow: 1 }}
        bodyStyle={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          rowGap: 16,
        }}
      >
        <DataGridApiProvider>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div>{props.actions}</div>
            <div style={{ display: 'flex' }}>
              <FiltersSettings
                extraFilters={extraFilters}
                filterModels={constraints.data.filter}
                onExtraFilterChange={handleExtraFilterChange}
                onResetAll={() => {
                  constraints.reset();
                }}
              />
              <ColumnsSettings style={{ marginRight: 8 }} />
              <FullscreenExpandButton
                isExpanded={isExpanded}
                onClick={toogleExpand}
              />
            </div>
          </div>

          <Loading active={loading} style={{ height: '100%' }}>
            <DataGrid
              initialConstraints={dataGridInitialConstaints}
              onChange={handleChange}
              rowData={rowData}
              columnDefs={columns}
              getRowId={getRowId}
              {...props}
            />
          </Loading>
        </DataGridApiProvider>
      </Card>
    </div>
  );
});
